/** "18 Std. 42 Min." until `target`, rounded up to the minute; null once it has passed. */
export const formatRemainingTime = (
  target: string | Date,
  now: Date = new Date()
): string | null => {
  const remainingMs = new Date(target).getTime() - now.getTime();
  if (remainingMs <= 0) return null;

  const totalMinutes = Math.ceil(remainingMs / 60_000);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  return hours > 0 ? `${hours} Std. ${minutes} Min.` : `${minutes} Min.`;
};

/** "Neuer Versuch in 18 Std. 42 Min." — the lock label on the summary and in the course menu. */
export const nextAttemptIn = (remaining: string): string =>
  `Neuer Versuch in ${remaining}`;

/** "Sa, 26.09., 09:14" */
export const formatQuizDateTime = (value: string | Date): string => {
  const parts = new Intl.DateTimeFormat("de-DE", {
    weekday: "short",
    day: "2-digit",
    month: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  }).formatToParts(new Date(value));
  const part = (type: string) => parts.find((p) => p.type === type)?.value;

  return `${part("weekday")?.replace(".", "")}, ${part("day")}.${part("month")}., ${part("hour")}:${part("minute")}`;
};

/** "09:14" */
export const formatQuizTime = (value: string | Date): string =>
  new Intl.DateTimeFormat("de-DE", {
    hour: "2-digit",
    minute: "2-digit",
  }).format(new Date(value));

export const percentOf = (correct: number, total: number): number =>
  total > 0 ? Math.round((correct / total) * 100) : 0;
